import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {

  carousel_images = [
    { src: '/assets/images/chat-banner-1.jpg' },
    { src: '/assets/images/chat-banner-2.jpg' }
  ];
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/landing-page/landing-page.component.ts